module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin_BG.8705d1bf.jpg";